import axios from 'axios';
import { useEffect, useState } from 'react';

const useForm = (callback, validate) => {
  const [values, setValues] = useState({});
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [regions, setRegions] = useState(null);
  const [organizations, setOrganizations] = useState([]);

  useEffect(() => {
    async function fetchRegions() {
      const result = await axios(`${process.env.REACT_APP_API_URL}/api/v1/regions`);
      setRegions(result.data);
    }
    async function fetchOrganizations() {
      const result = await axios(`${process.env.REACT_APP_API_URL}/api/v1/organizations`);
      setOrganizations(result.data);
    }

    fetchOrganizations();
    fetchRegions();
  }, []);

  useEffect(() => {
    if (Object.keys(errors).length === 0 && isSubmitting) {
      callback();
    }
  }, [callback, errors, isSubmitting]);

  const handleSubmit = (event) => {
    if (event) event.preventDefault();
    setErrors(validate(values));
    setIsSubmitting(true);
  };

  const handleChange = (event) => {
    event.persist();
    setValues((values) => ({
      ...values,
      [event.target.name]: event.target.value,
    }));
  };

  return {
    handleChange,
    handleSubmit,
    values,
    errors,
    regions,
    organizations,
  };
};

export default useForm;
